import React, { Component } from "react";
import MenuBar from "../../layouts/MenuBar";
import "../../styles/style.css";
import Footer from "../../layouts/Footer";
import { connect } from "react-redux";
import bizd from "../../assets/img/Turbnew.jpg";
import biz from "../../assets/img/Turbnew.jpg";
import { toast, ToastContainer } from "react-toastify";
import { Turboaction } from "../../state-management/actions/auth/TurboActions";
import PropTypes from "prop-types";
import { getCountries } from "../../state-management/actions/location/location-action";

import "./index.css";

class Turbos extends Component {
  constructor(props) {
    super(props);
    // let styleList = this.props.location.state.plan;
    // console.log(styleList);
    this.state = {
      first: "",
      last: "",
      address: "",
      email: "",
      alternateEmail: "",
      phone: "",
      country: "",
      state: "",
      alternatePhone: "",
      referral: "",
      passsword: "",
      plan: this.props.location.state
        ? this.props.location.state.plan
        : "Turbo Connect",
      planName: this.props.location.state
        ? this.props.location.state.planName
        : "turbo_connect",
      amount: this.props.location.state
        ? this.props.location.state.amount
        : "76000",
      about: "",
      source: "",
      phoneError: "",
      terms: false,
      payment_option: "paystack",
    };
  }

  static propTypes = {
    load: PropTypes.bool.isRequired,
  };

  //   let searchParams = useParams();

  //   const { reference } = searchParams;

  //   if (!reference) {
  //     return <p>Page not found</p>;
  //   }

  Turboaction = (e) => {
    e.preventDefault();
    const {
      first,
      last,
      address,
      email,
      phone,
      source,
      payment_option,
      amount,
      country,
      state,
      planName,
    } = this.state;
    const { location } = this.props;
    const price = amount;
    const data = {
      firstName: first,
      lastName: last,
      address,
      email,
      phoneNumber: phone,
      language: "english",
      country,
      state,
      allowEmail: true,
      plan: planName,
      about_us: source,
      payment_option,
    };
    const numbers = /^[0-9]+$/;
    if (!phone.match(numbers)) {
      toast.info("Please enter only numbers");
    } else if (phone.length !== 11) {
      toast.info("invalid phone number");
    } else {
      this.props.Turboaction(data, price, this.props.history);
    }
  };

  onChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
    });

  handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  handleNumber = (e) => {
    const { name, value } = e.target;
    if (isNaN(Number(value))) return;
    this.setState({ [name]: value });
  };

  handleSpaceBar = (e) => {
    if (e.keyCode === 32) e.preventDefault();
  };
  submitForm() {
    const { first, last, address, email, phone, terms, country, state } =
      this.state;
    return (
      first.length > 0 &&
      last.length > 0 &&
      address.length > 0 &&
      email.length > 0 &&
      state.length > 0 &&
      country.length > 0 &&
      phone.length === 11 &&
      terms
    );
  }

  componentDidMount() {
    this.props.getCountries();
  }

  displayStateAndRegions = () => {
    if (this.state.country === "gh") {
      return this.props.countries
        .filter((country) => country.country === "Ghana")
        .map((state) => <option value={state.state}>{state.state}</option>);
    } else if (this.state.country === "cv") {
      return this.props.countries
        .filter((country) => country.country === "Cote d'Ivoire")
        .map((state) => <option value={state.state}>{state.state}</option>);
    } else {
      return this.props.countries
        .filter((country) => country.country === "Nigeria")
        .map((state) => <option value={state.state}>{state.state}</option>);
    }
  };

  render() {
    const { load, location } = this.props;
    const isEnabled = this.submitForm();

    const { first, last, address, email, phone, terms } = this.state;
    return (
      <div>
        <MenuBar />
        <div className="col-md-8 col-12 m-auto ">
          {location.state ? (
            <>
              <h1 className="mt-4">{location.state.plan}</h1>
              <p>
                The Next Generation of our Unlimited Internet,{" "}
                {location.state.plan} will provide data and voice services to
                Enterprise Business District, Estate, Multi-Story Building, and
                Housing Complex. Tizeti proposes providing a wireless network
                solution for your organization in the following capacity;
                Digital landline Telephone, Surveillance, Internet Service etc.
              </p>
            </>
          ) : (
            <>
              <h1 className="mt-4">Tizeti Turbo Connect</h1>
              <p>
                The Next Generation of our Unlimited Internet, Tizeti Turbo
                Connect will provide data and voice services to Enterprise
                Business District, Estate, Multi-Story Building, and Housing
                Complex. Tizeti proposes providing a wireless network solution
                for your organization in the following capacity; Digital
                landline Telephone, Surveillance, Internet Service etc.
              </p>
            </>
          )}
          <img
            class="img-fluid"
            src={
              location.state
                ? location.state.planName === "turbo_connect"
                  ? bizd
                  : biz
                : bizd
            }
          />
        </div>
        <div className="col-md-4 col-12 m-auto">
          <form className="form-horizontal mt-3" onSubmit={this.Turboaction}>
            <div className="form-group text-left">
              <div className="d-flex">
                <div className="mb-3 mr-auto col pl-0">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="first"
                    value={first}
                    onChange={this.onChange}
                    className="form-control"
                    placeholder="First Name"
                  />
                </div>

                <div className="mb-3 col pr-0">
                  <label>Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last"
                    value={last}
                    onChange={this.onChange}
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label>Phone Number</label>
                <input
                  type="tel"
                  pattern="0[789]{1}[01]{1}[0-9]{8}"
                  title="Please enter your valid 11-digit phone number"
                  className="form-control"
                  name="phone"
                  value={phone}
                  maxLength="11"
                  placeholder="Phone number"
                  onChange={this.handleNumber}
                  onKeyDown={this.handleSpaceBar}
                />
              </div>

              <div className="mb-3">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.onChange}
                  className="form-control"
                  placeholder="Contact email address"
                />
              </div>

              <div className="mb-3">
                <label>How Did You Hear About Us?</label>
                <select
                  className="form-control"
                  name="source"
                  onChange={this.onChange}
                >
                  <option value="">Select</option>

                  <option value="google ads">Google Ads</option>
                  <option value="facebook">Facebook</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="flyer">Flyer</option>
                  <option value="billboard">Billboard</option>
                  <option value="mobile advert">Mobile Advert</option>
                  <option value="friend">Friend</option>
                  <option value="instagram">Instagram</option>
                  <option value="television">Television</option>
                  <option value="radio">Radio</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="mb-3">
                <label>Country</label>
                <select
                  className="form-control"
                  name="country"
                  onChange={this.onChange}
                  required
                >
                  <option required>Select Country</option>
                  {this.props.countries
                    .filter(
                      (item, index, i) =>
                        i.findIndex((t) => t.country === item.country) === index
                    )
                    .map((country) => (
                      <option value={country.country === "Ghana" ? "gh" : "ng"}>
                        {country.country}
                      </option>
                    ))}
                </select>
              </div>

              <div className="mb-3">
                <label>State</label>
                <select
                  className="form-control"
                  name="state"
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  required
                >
                  <option>Select State</option>
                  {this.displayStateAndRegions()}
                </select>
              </div>

              <div className="mb-3">
                <label>Physical Address</label>
                <textarea
                  className="form-control"
                  name="address"
                  value={address}
                  onChange={this.onChange}
                  placeholder="Physical address"
                  rows="5"
                />
              </div>

              <>
                <input
                  type="checkbox"
                  name="terms"
                  className="check"
                  checked={terms}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="vehicle1">
                  By signing up, you agree to our{" "}
                  <a href="http://wifi.com.ng/terms" className="terms-link">
                    Terms and Conditions
                  </a>
                </label>
              </>
              <div className="mb-3">
                {load ? (
                  <input
                    disabled={true}
                    className="btn signup-btn w-100 text-white"
                    value="Submitting..."
                    type="submit"
                  />
                ) : (
                  <input
                    disabled={!isEnabled}
                    className="btn signup-btn w-100 text-white"
                    value="Proceed"
                    type="submit"
                  />
                )}
              </div>
            </div>
          </form>
        </div>
        <ToastContainer />
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  load: state.signUp.load,
  countries: state.location.countries,
});

export default connect(mapStateToProps, { Turboaction, getCountries })(Turbos);
